import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Checkbox, Row, Col } from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Team from './Team';
import NewTeam from './NewTeam';
import DeleteConfrimModal from './DeleteConfrimModal';
import SearchBar from '../SearchBar';

class TeamsList extends Component {
  constructor() {
    super();
    this.state = {
      showArchivedTeams: false,
      openModal: false,
      selectedTeam: null,
      mode: 'all',
      searchText: '',
    };
  }

  componentWillMount() {
    this.props.loadTeams();
  }

  componentWillReceiveProps(nextProps) {
    const { status } = nextProps;

    if (status !== this.props.status) {
      if (status === actionTypes.TEAM_DELETE_ERROR) {
        this.props.hideAlert();
        this.props.alert(
          'error',
          'Oops! cannot delete the team because collaborator is already included on an agreement.'
        );
      } else if (status === actionTypes.TEAM_RECOVER_ERROR) {
        this.props.hideAlert();
        this.props.alert('error', 'Oops! cannot recover the team.');
      }
    }
  }

  getTeams() {
    const { type, teams } = this.props;
    const { showArchivedTeams, searchText } = this.state;

    let buttonTitle = 'select';
    if (type === 'view') {
      buttonTitle = 'view';
    }
    if (showArchivedTeams) {
      buttonTitle = 'recover';
    }

    if (teams !== null) {
      return teams
        .filter((team) => team.archived === showArchivedTeams)
        .filter((team) =>
          team.name.toLowerCase().includes(searchText.toLowerCase())
        )
        .map((team, i) => (
          <Team
            key={i}
            team={team}
            button={buttonTitle}
            showArchivedTeams={showArchivedTeams}
            handleClick={this.teamSelect}
          />
        ));
    }
  }

  teamSelect = (team, isDelete = false) => {
    this.props.selectTeam(team);

    if (this.state.showArchivedTeams) {
      // Recover or delete the archived team
      if (isDelete) {
        this.setState({ openModal: true, selectedTeam: team, mode: 'delete' });
      } else {
        this.setState({ openModal: true, selectedTeam: team, mode: 'recover' });
      }
    } else {
      if (this.props.type === 'view') {
        this.props.router.push(`/teams/${team.id}/detail`);
      } else if (this.props.type === 'create') {
        this.props.assign('newTeam', false);
      }
    }
  };

  delete() {
    const { selectedTeam } = this.state;

    if (selectedTeam) {
      this.props.deleteTeam(selectedTeam.id);
      this.onCloseModal();
    }
  }

  recover() {
    const { selectedTeam } = this.state;

    if (selectedTeam) {
      this.props.recoverTeam(selectedTeam.id);
      this.onCloseModal();
    }
  }

  onCloseModal() {
    this.setState({ openModal: false, selectedTeam: null });
  }

  onShowArchivedTeams() {
    this.setState((state) => ({
      showArchivedTeams: !state.showArchivedTeams,
    }));
  }

  handleSearch = (e) => {
    e.preventDefault();
    this.setState({ searchText: e.target.value });
  };

  clearSearch = (e) => {
    e.preventDefault();
    this.setState({ searchText: '' });
  };

  render() {
    const { type } = this.props;
    const { showArchivedTeams, openModal, mode, searchText } = this.state;

    return (
      <div className="teams-list-container">
        {type === 'view' && (
          <Row className="team-intro">
            <Col>
              <h4 className="text-center">
                Before creting an agreements, create or select a team of
                collaborators from the list below.
              </h4>
            </Col>
          </Row>
        )}

        {type === 'view' && <NewTeam type={type} />}

        {type === 'view' && (
          <SearchBar
            searchText={searchText}
            handleSearch={this.handleSearch}
            clearSearch={this.clearSearch}
          />
        )}

        {type === 'view' && (
          <Row className="btn-archive w-100">
            <Col md={12} className="text-center">
              <Checkbox
                className="btn-archived-team"
                checked={showArchivedTeams}
                onChange={() => this.onShowArchivedTeams()}
              >
                Show Archived Teams
              </Checkbox>
            </Col>
          </Row>
        )}

        <div className="teams-list d-flex">
          {type !== 'view' && !showArchivedTeams && <NewTeam type={type} />}
          {this.getTeams()}
        </div>

        <DeleteConfrimModal
          open={openModal}
          mode={mode}
          delete={() => this.delete()}
          recover={() => this.recover()}
          onClose={() => this.onCloseModal()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  teams: state.teams.teams,
  status: state.teams.status,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assign: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
  loadTeams: () => {
    dispatch(actions.getTeams());
  },
  selectTeam: (team) => {
    dispatch(actions.selectTeam(team));
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
  recoverTeam: (teamId) => {
    dispatch(actions.recoverTeam(teamId));
  },
  deleteTeam: (teamId) => {
    dispatch(actions.deleteTeam(teamId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TeamsList));



// WEBPACK FOOTER //
// src/components/Teams/TeamsList.jsx